import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface LogoutProps {
  redirectTo?: string;
}
const Logout: React.FC<LogoutProps> = ({ redirectTo }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    const _redirectTo = queryParams.get('redirect-to');
    localStorage.clear();
    if (redirectTo) {
      window.location.href = redirectTo;
    } else {
      window.location.href = _redirectTo;
    }
  }, []);

  return null;
};

export { Logout };
